/* eslint-disable react/no-array-index-key */
import React, { Ref } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dropdown } from 'react-bootstrap';

interface ForwardRefProps {
  toggleClassName: any,
  variant: any,
  icon: any,
  onClick: (event)=>void,
  children: any
}

const customToggle = React.forwardRef((props: ForwardRefProps, ref : Ref<HTMLButtonElement>) => (
  <Button
    aria-label="User Menu"
    className={props.toggleClassName}
    variant={props.variant}
    ref={ref}
    onClick={(e) => {
      props.onClick(e);
    }}
  >
    <FontAwesomeIcon icon={props.icon} />
    {props.children}
  </Button>
));

interface DropDownIconMenuProps {
  icon: any,
  variant: any,
  id: any,
  toggleClassName: any,
  items: any
  onSelect: (item: any) => void
}

export default function DropDownIconMenu(props: DropDownIconMenuProps) {
  return (
    <Dropdown>
      <Dropdown.Toggle
        as={customToggle}
        variant={props.variant}
        id={props.id}
        icon={props.icon}
        toggleClassName={props.toggleClassName}
      />
      <Dropdown.Menu>
        {props
                    && props.items.map((item, index) => (
                      <Dropdown.Item key={index} eventKey={item} onClick={() => props.onSelect(item)}>
                        <div className="d-flex">
                          <div className="fa-fw d-flex align-items-center justify-content-center dropdown-menu-icon">
                            {item && item.icon && <FontAwesomeIcon icon={item.icon} />}
                          </div>
                          <div className="pl-3 flex-column">
                            {Array.isArray(item.text) ? (
                              item.text.map((s, index) => <div key={index}>{s}</div>)
                            ) : (
                              <div>{item.text}</div>
                            )}
                          </div>
                        </div>
                      </Dropdown.Item>
                    ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
